import { UtilityName, UtilityPaymentFrequency } from './types';

export const INFO_ICONS = {
  'type.single': '/icons/96x96/icon_96_hp_single_home.png',
  'type.multi': '/icons/96x96/icon_96_hp_multi_homes.png',
  'type.few': '/icons/96x96/icon_96_hp_fewhome.png',
  'level.default': '/icons/96x96/icon_96_hp_low_rise.png',
  'level.penthouse': '/icons/96x96/icon_96_hp_high_rise.png',
  parking: '/icons/96x96/icon_96_hp_parking.png',
  'pets.yes': '/icons/96x96/icon_96_hp_pet.png',
  'pets.no': '/icons/96x96/icon_96_hp_no_pet.png',
  heat: '/icons/96x96/icon_96_hp_heat.png',
  cooling: '/icons/96x96/icon_96_hp_ac.png',
  laundry: '/icons/96x96/icon_96_hp_laundry.png',
};

export const INFO_ICONS_SUBTITLES = {
  'type.single': 'Single Family',
  'type.multi': 'Multi-Unit',
  'type.other': 'Other',
  'level.penthouse': 'Penthouse',
  'level.ground': 'Ground Level',
  'level.basement': 'Basement Level',
  'pets.any': 'Pet Friendly',
  'pets.dogs': 'Dogs Only',
  'pets.cats': 'Cats Only',
  'pets.no': 'No Pets',
  'heat.no': 'No Heat',
  'cooling.yes': 'A/C',
  'cooling.no': 'No A/C',
  'cooling.central': 'Central A/C',
  'laundry.no': 'No Laundry',
};

export const INFO_ICONS_TITLES = {
  type: 'Type',
  level: 'Level',
  parking: 'Parking',
  pets: 'Pets',
  heat: 'Heat',
  cooling: 'Cooling',
  laundry: 'Laundry',
};

export const UTILITY_TO_SRC_MAP: Record<UtilityName, string> = {
  Water: 'icons/96x96/icon_96_utility_water.svg',
  Gas: 'icons/96x96/icon_96_utility_appliances.svg',
  Electricity: 'icons/96x96/icon_96_utility_electronic.svg',
  Trash: 'icons/96x96/icon_96_utility_garbage.svg',
  Sewage: 'icons/96x96/icon_96_utility_sewer.svg',
  Cable: 'icons/96x96/icon_96_utility_cable.svg',
  Internet: 'icons/96x96/icon_96_utility_interenet.svg',
  Cleaning: 'icons/96x96/icon_96_utility_cleaning.svg',
  Storage: 'icons/96x96/icon_96_pro_storage_unselected.svg',
  Parking: 'icons/96x96/icon_96_hp_parking.png',
  Landscaping: 'icons/96x96/icon_96_utility_andscape.svg',
  PoolServicing: 'icons/96x96/icon_96_utility_pool.svg',
};

export const CYCLE_TO_FREQUENCY_MAP: Record<UtilityPaymentFrequency, string> = {
  Monthly: '/Month',
  Quarterly: '/Quarter',
  Annually: '/Year',
  OneTime: '',
};
